import type { RootState } from "@/app/store";
import type { SaveItem, SavePageMode } from "@/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SaveState {
    saveItem: SaveItem | null,
    saveMode: SavePageMode,
}

const initialState: SaveState = {
    saveItem: null,
    saveMode: 'new'
}

export const saveSlice = createSlice({
    name: 'save',
    initialState,
    reducers: {
        setSaveItem: (state, action: PayloadAction<SaveItem | null>) => {
            state.saveItem = action.payload;
        },
        setSaveMode: (state, action: PayloadAction<SavePageMode>) => {
            state.saveMode = action.payload;
        },
    }
})

export const { setSaveItem, setSaveMode } = saveSlice.actions;

export const saveItem = (state: RootState) => state.save.saveItem;
export const saveMode = (state: RootState) => state.save.saveMode;

export default saveSlice.reducer;
